require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.string.pad-start");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.array.reduce");

var rgbaKeys = ['r', 'g', 'b', 'a'];

function StringToRgba(string) {
  return string.replace(/(rgba?\(|\))/, '').split(',').reduce(function (color, values, index) {
    color[rgbaKeys[index]] = parseFloat(values);
    return color;
  }, {});
}

function RgbaToString(color) {
  return "rgba(".concat(color.r, ",").concat(color.g, ",").concat(color.b, ",").concat(color.a, ")");
}

function fade(string, opacity, escape) {
  var rgba = StringToRgba(string);
  rgba.a = opacity;
  var color = RgbaToString(rgba);
  return escape ? encodeURIComponent(color) : color;
}

function fadeToUrl(string, opacity) {
  var _StringToRgba = StringToRgba(string),
      r = _StringToRgba.r,
      g = _StringToRgba.g,
      b = _StringToRgba.b;

  return RgbaToUrl({
    r: r,
    g: g,
    b: b,
    a: opacity
  });
}

function RgbaToUrl(rgba) {
  var r = rgba.r,
      g = rgba.g,
      b = rgba.b,
      a = rgba.a;
  return [r, g, b, a * 255].map(function (c) {
    return c.toString(16).substring(0, 2).padStart(2, '0');
  }).join('');
}

function HexToRGBA(color) {
  var alpha = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  if (!color) {
    return 'none';
  }

  var r = parseInt(color.substring(1, 3), 16);
  var g = parseInt(color.substring(3, 5), 16);
  var b = parseInt(color.substring(5, 7), 16);
  var a = alpha / 100;
  return "rgba(".concat(r, ",").concat(g, ",").concat(b, ",").concat(a, ")");
}

module.exports = {
  StringToRgba: StringToRgba,
  RgbaToString: RgbaToString,
  fade: fade,
  fadeToUrl: fadeToUrl,
  RgbaToUrl: RgbaToUrl,
  HexToRGBA: HexToRGBA
};